var _path, _circle, _circle2, _circle3, _circle4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgColorPalet(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 128,
    height: 129,
    viewBox: "0 0 128 129",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M57.3759 128.09C0.37588 128.09 -35.5938 16.5386 55.3759 0.590461C113.375 -7.40957 149.138 68.2809 111.875 82.5905C111.648 82.6775 111.413 82.7776 111.165 82.8831C108.713 83.9264 105.031 85.4926 96.3751 80.0904C88.9062 75.4291 84.9751 81.8904 87.3751 91.0904C91.7089 103.757 91.7764 128.89 57.3759 128.09ZM59.4999 114C68.0603 114 74.9999 107.06 74.9999 98.5C74.9999 89.9396 68.0603 83 59.4999 83C50.9395 83 43.9999 89.9396 43.9999 98.5C43.9999 107.06 50.9395 114 59.4999 114Z",
    fill: "#FFBB33"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 29.5,
    cy: 72.5,
    r: 15.5,
    fill: "#3D6DCC"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 38.5,
    cy: 30.5,
    r: 11.5,
    fill: "#B8E65C"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 72.5,
    cy: 19.5,
    r: 11.5,
    fill: "#AA80FF"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 97.5,
    cy: 46.5,
    r: 11.5,
    fill: "#F25A3C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgColorPalet);
export default __webpack_public_path__ + "static/media/color-palet.057991e034a50398eeed3f6fdfca7eae.svg";
export { ForwardRef as ReactComponent };